<ng-container *ngIf="!isOptionLoading;else loading">
  <app-nav-header [CompanyID]="CompanyID" [UserID]="UserID" [Liff_ID]="Liff_ID"></app-nav-header>  
  <div class="profile-container">
    <!-- 頂部背景區 -->
    <div class="header-area">
      <div class="header-left">
        <img [src]="avatarUrl" alt="" class="avatar" (error)="onImgError($event)">
      </div>
      <div class="header-right">
        <div class="company-name">{{ model.CompanyName }}</div>
        <div class="company-address">{{ model.Address }}</div>
        <div class="company-phone">{{ model.phone }}</div>
      </div>
      <h2 class="welcome">
            {{ model.MemberName }}，您好
      </h2>
    </div>

    <!-- 資料卡片 -->
    <div *ngIf="isRes || isBook" class="booking-buttons">
      <button *ngIf="isRes" class="outline-btn" (click)="goReserve()">
        <img src="assets/images/content_cut.svg" width="20" height="20" class="me-2"/>美容預約
      </button>
      <button *ngIf="isBook" class="outline-btn" (click)="goBook()">
        <img src="assets/images/bed.svg" width="20" height="20" class="me-2"/>住宿預約
      </button>
    </div>

    <!-- 其他 -->
    <div class="menu-container">
      <p-menu [model]="items" class="custom-menu">
          <ng-template pTemplate="item" let-item>
              <a 
                  [routerLink]="item.route" 
                  [href]="item.url"
                  class="p-menuitem-link custom-menu-item"
              >
                  <span class="left-area">
                      <img *ngIf="item.svg" [src]="item.svg" width="20" height="20" class="menu-icon"/>
                      <span class="label-text">{{ item.label }}</span>
                  </span>

                  <span class="right-arrow">›</span>
              </a>
          </ng-template>
      </p-menu>
  </div>
  </div>
</ng-container>
<ng-template #loading>
<p-progressSpinner ariaLabel="loading" />
</ng-template>